
import { CustomState } from "@iewc/Store/Reducers";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: CustomState) => {
    const fieldName = "regularUpdates";
    return {
        fieldName,
        fieldValue: state.components.contactUsForm.fieldValues[fieldName],
    };
};

const mapDispatchToProps = {
    setFieldValue,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface FormFieldStyles {
    radioGroup?: RadioGroupProps;
}

export const formFieldStyles: FormFieldStyles = {
    radioGroup: {
        css: css`
            legend {
                font-size: 16px;
                line-height: 26px;
            }
        `,
    },
};

const styles = formFieldStyles;

const RegularUpdates: React.FC<Props> = ({ fieldName, fieldValue, setFieldValue }) => { 

    const fieldChangeHandler = (value: boolean) => {
        setFieldValue({ key: fieldName, value: `${value}` }); // Ensure the value is updated dynamically
    };

    React.useEffect(() => {
        if (!fieldValue) {
            setFieldValue({ key: fieldName, value: "false" }); // Initialize only if fieldValue is not already set
        }
    }, [fieldValue]);
    
    return (
        <RadioGroup
            {...styles.radioGroup}
            onChange={(e: any) => fieldChangeHandler(e.target.value)}
            value={fieldValue}
            label={`${translate("Sign up for regular updates from Anixter?")}`}
        >
            <Radio value="true">{translate("Yes, I would like to sign up")}</Radio>
            <Radio value="false">{translate("No, I am not ready to sign up")}</Radio>
        </RadioGroup>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RegularUpdates) as any,
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
    },
};

export default widgetModule;
